import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
    selector: 'app-contact-warning',
    templateUrl: './group-type-warning.component.html'
})

export class GroupTypeWarningDialogComponent {
    groupType: string;
    constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
        this.groupType = data;
    }
}
